<template>
  <div class="cmp-booking-templates-template_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="add-button">
        <img @click="onAddNewTemplateClicked" class="dt-icon" src="static/buttons/add.svg" alt />
      </div>
    </div>

    <div class="dt-page--data-table">
      <NTable id="booking-templates-template_list" class="h1" :config="tableConfig" :items="bookingTemplates"
        :headers="headers">
        <template v-slot:item="{ item, tdcon }">
          <tr style="cursor: pointer" class="booking-request-row">
            <td v-bind="tdcon('template')" @click="onRowClicked(item)">
              <span>{{ item["booking_template_name"] }}</span>
            </td>
            <td v-bind="tdcon('description')">
              <span>{{ item["subject"] }}</span>
            </td>
            <td v-bind="tdcon('type')">
              <span>{{ item["type"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img @click.stop="(e) => deleteTemplate(item)" src="static/icons/delete.svg" class="dt-icon v5 s2" />
              </div>
            </td>
          </tr>
        </template>
      </NTable>

      <!-- <v-data-table
        :headers="headers"
        :items="bookingTemplates"
        hide-actions
        class="dt-table booking-table elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr class="booking-request-row">
            <td @click="onRowClicked(props.item)">{{ props.item['booking_template_name']}}</td>
            <td>{{ props.item['subject'] }}</td>
            <td>{{ props.item['type'] }}</td>
            <td>
              <v-btn small flat icon color="pink" @click="e => deleteTemplate(props.item)">
                <v-icon>close</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table> -->
    </div>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="templateDetailsFlag"
      @closed="closeTemplateDetails">
      <BookingTemplatesSidewindow></BookingTemplatesSidewindow>
    </Sidewindow>
  </div>
</template>

<script>
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../store/types";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";

import { ConfirmationService } from "../../../dt-plugins/confirmation/confirmation.service";

import BookingTemplatesSidewindow from "../components/templates/booking-templates-sidewindow";
import { bookingTemplatesService } from "../services/booking-templates.service";
import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import { childOfOrEqual, createRouteName } from "../../../router/functions";
import { templateDetailsSelectable } from "../router";
import { bookingTemplateListLDTRoutes, getBookingTemplateDetailsSelectable } from "../router/routes";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { childOfOrEqualDetails, handleFromRoute } from "../../../utility/route";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";

const bookingTemplateListRoute = "booking_templates";
const bookingTemplateDetailsRoute = createRouteName(
  bookingTemplateListRoute,
  "template_details"
);
const bookingTemplateDetailsTabRoute = createRouteName(
  bookingTemplateDetailsRoute,
  "tab"
);

const SelectResults = {
  SELECT: "SELECT",
  SELECT_AUTO: "SELECT_AUTO",
  IGNORE: "IGNORE",
  CLOSE: "CLOSE",
};
const newTemplate = {
  booking_template_name: "new contract",
  subject: "",
  type: "contract",
  body_text: "",
  loop1_text: "",
  loop2_text: "",
  loop3_text: "",
  loop4_text: "",
  loop5_text: "",
  loop6_text: "",
  loop7_text: "",
  loop8_text: "",
  loop9_text: "",
  loop10_text: "",
};

const LDTConfig = {
  entityName: "bookingTemplate",
  ldtRoutes: bookingTemplateListLDTRoutes,
  detailsSelectableFunction: getBookingTemplateDetailsSelectable,
  primaryKey: "booking_template_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.TemplateDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.TemplateDetails.FETCH.SINGLE,
  listKey : 'bookingTemplates'
};

export default {
  components: {
    BookingTemplatesSidewindow,
    NTable,

    Sidewindow,
  },
  data: function () {
    return {
      bookingTemplateDetailFlag: false,
      selectedBookingTemplate: {},
      firstTemplateDetails: {},
      newAddedTemplateID: null,

      loadingFlag: false,
    };
  },
  mounted: function () {
    this.routeMount();
    this.fetchList();
  },
  computed: {
    ...mapGetters(storeNS, {
      bookingTemplates: "bookingTemplates",
    }),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    headers: function () {
      return [
        createTableHeader("template", { fw: 700 }),
        createTableHeader("description"),
        createTableHeader("type"),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
    templateDetailsFlag: function () {
      // return childOfOrEqual(bookingTemplateDetailsRoute)(this.$route.name);
      return childOfOrEqualDetails(bookingTemplateListLDTRoutes, this.$route);
    },
  },
  mixins: [createLDTHost(LDTConfig)],
  watch: {    
    /* bookingTemplates: function (templates) {
      if (templates.length > 0) {
        this.newAddedTemplateSetAsSelected(templates);

        let firstTemplate = templates[0];
        bookingTemplatesService
          .getBookingTemplate(firstTemplate.booking_template_id) // <- Details Request, should use this always for Details
          .then((res) => {
            this.firstTemplateDetails = res.data;
            // console.log(this.firstTemplateDetails);
          });
      }
    }, */
    // $route: {
    //   immediate: true,
    //   handler: function (to, from) {
    //     const { selectResult, bookingTemplateId } = templateDetailsSelectable(
    //       to,
    //       from
    //     );

    //     switch (selectResult) {
    //       case SelectResults.SELECT: {
    //         this.selectTemplate(bookingTemplateId);
    //         break;
    //       }
    //       case SelectResults.SELECT_AUTO: {
    //         this.selectTemplateAuto(bookingTemplateId);
    //         break;
    //       }
    //       case SelectResults.CLOSE: {
    //         this.closeTemplateDetails();
    //         break;
    //       }
    //       case SelectResults.IGNORE: {
    //         break;
    //       }
    //     }

    //     console.log(selectResult);
    //   },
    // },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GET_BOOKING_TEMPLATES]: ActionTypes.GET_BOOKING_TEMPLATES,
      [ActionTypes.DELETE_BOOKING_TEMPLATE]:
        ActionTypes.DELETE_BOOKING_TEMPLATE,
      [ActionTypes.ADD_BOOKING_TEMPLATE]: ActionTypes.ADD_BOOKING_TEMPLATE,
      [ActionTypes.SelectedBookingTemplate.FETCH.SINGLE]:
        ActionTypes.SelectedBookingTemplate.FETCH.SINGLE,
    }),

    async deleteTemplate(item) {
      const confirmationResult = await confirmDelete(
        "Template",
        item.booking_template_name
      );
      if (confirmationResult === "OK") {
        this.bookingTemplates = this.bookingTemplates.filter(
          (row) => row.booking_template_id != item.booking_template_id
        );
        this[ActionTypes.DELETE_BOOKING_TEMPLATE](item.booking_template_id);
      }
      // ConfirmationService.create({
      //   subject: "Do you really want to delete this template ?",
      //   model: true,
      //   width: 500,
      //   completed: (res) => {
      //     switch (res) {
      //       case "OK": {
      //         this.bookingTemplates = this.bookingTemplates.filter(
      //           (row) =>
      //             row.booking_template_id !=
      //             item.booking_template_id
      //         );
      //         this[ActionTypes.DELETE_BOOKING_TEMPLATE](
      //           item.booking_template_id
      //         );
      //         break;
      //       }
      //       default: {
      //       }
      //     }
      //   },
      // });
    },

    onRowClicked(item) {
      /*
      this.selectedBookingTemplate = item;
      this.bookingTemplateDetailFlag = true;

      // SubProper Solution
      // Refactor Store into separate submodule
      // New Action for getting Template Details + Setting Template Details
      // Fetch List HTTP Call, then find function => Set Selected

      // Quick Solution
      // 1. Make Booking Templates Submodule Store (store/templates/)
      // 2. Fetch Template Details (Actions, types, ....) {} {}
      // 3. ** Inside the Fetch Action (SelectedBookingTemplate.FETCH.SINGLE) - write this - commit(SET_MAIN_NAV_ACTIVE, !flag, { root: true });
      // 4. selectTemplate, selectTemplateAuto, closeTemplateDetails --- Dispatch SelectedBookingTemplate.FETCH.SINGLE
      // Example -
      // this[ArtistActionTypes.SelectedBookingTemplate.FETCH.SINGLE]({
      //   flag: true,
      //   booking_template_id: { booking_template_id },
      // });

      // 5. 6.

      // After Quick SOlution
      // 1. Templates.FETCH.ALL -> Move Template List to Vuex (Action+Mutation)
      // 2. SelectedBookingTemplate.FETCH.SINGLE -> Move selectedBookingTemplate to Vuex
      // 3. Inside this action - getters.templates.find(=> booking_template_id)
      // 4. Call Mutation

      // console.log(this.selectedBookingTemplate);

      const tab = this.$route.params.tab;

      // console.log(bookingTemplateDetailsTabRoute);

      if (tab) {
        this.$router.push({
          name: bookingTemplateDetailsTabRoute,
          params: {
            booking_template_id: item.booking_template_id,
            tab: tab,
          },
        });
      } else {
        this.$router.push({
          name: bookingTemplateDetailsTabRoute,
          params: {
            booking_template_id: item.booking_template_id,
            tab: "overview",
          },
        });
      } */

      this.$router.push({
        name: bookingTemplateListLDTRoutes.names.tab,
        params: {
          booking_template_id: item.booking_template_id,
          tab: this.$route.params.tab ? this.$route.params.tab : "overview",
        },
      });
    },

    routeMount: function () {
      // console.log(this.$route.name);
    },

    onAddNewTemplateClicked() {
      this.selectedBookingTemplate = newTemplate;
      this.bookingTemplateDetailFlag = true;
      this[ActionTypes.ADD_BOOKING_TEMPLATE](newTemplate).then(
        (addedTemplateID) => {
          this.newAddedTemplateID = addedTemplateID;
          // console.log("New Added Template ID: ", addedTemplateID);
          this.onRowClicked({booking_template_id: addedTemplateID});
        }
      );
    },

    newAddedTemplateSetAsSelected(templates) {
      let newAddedTemplateID = this.newAddedTemplateID;
      if (newAddedTemplateID) {
        // console.log("newAddedTemplateID: ", newAddedTemplateID);
        this.selectedBookingTemplate = templates.find(
          (row) => row.booking_template_id == newAddedTemplateID
        );
        this.bookingTemplateDetailFlag = true;
        this.newAddedTemplateID = null;
      }
    },

    fetchList: async function () {
      this.loadingFlag = false;
      await this[ActionTypes.GET_BOOKING_TEMPLATES]();
      this.loadingFlag = true;
    },

    selectTemplate: function (booking_template_id) {
      this[ActionTypes.SelectedBookingTemplate.FETCH.SINGLE]({
        flag: true,
        template: { booking_template_id },
      });
    },

    selectTemplateAuto: function (booking_template_id) {
      this[ActionTypes.SelectedBookingTemplate.FETCH.SINGLE]({
        flag: true,
        template: { booking_template_id },
      });
    },

    closeTemplateDetails: function () {
      // this.$router.push({ name: bookingTemplateListRoute });
      // this[ActionTypes.SelectedBookingTemplate.FETCH.SINGLE]({
      //   flag: false,
      // });

      handleFromRoute(this, () => {
        this.$router.push({
          name: bookingTemplateListLDTRoutes.names.list,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-ntable {
  --ntable-height: calc(100vh - 135px);
}

tr.booking-request-row td {
  /* line-height: normal !important; */
}

.top-bar {
  display: flex;
  // background: wheat;
  margin-left: 15px;
  margin-bottom: 10px;

  color: var(--text-primary);

  .add-button {
    flex: 0.015;

    img {
      margin-top: 5px;
    }
  }
}
</style>